// @flow
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Cleave from 'cleave.js/dist/cleave-react';

import style from './InputWeight.scss';
import inputStyle from '../../assets/styles/input.scss';


type Props = {
  +weightUnit: {
    value: string;
  };
  +name: string;
  +className?: string;
  +hasError?: boolean;
  +errors?: string[];
  +value: string;
  +handleFocusInputText?: (e: Event) => void;
  +handleChangeWeightUnit: (unit: string) => void;
  +handleChangeCleave: (e: Event) => void;
  +handleBlurCleave: (e: Event) => void;
  +handleInit: (cleave: Cleave) => void;
  +handleRef?: (ref: any) => void;
};

const units = ['kg', 'lbs'];

export default class InputWeight extends Component<Props> {
  isAppleMobile: boolean = true;

  componentDidMount() {
    this.isAppleMobile = /iPad|iPhone|iPod/i.test(navigator.userAgent);
  }

  render() {
    const {
      weightUnit, handleChangeWeightUnit, handleChangeCleave, value, hasError, errors,
      handleBlurCleave, handleInit, handleRef, handleFocusInputText, className, name,
    } = this.props;

    return (
      <section className={classNames(style.inputWeight,
        { [style.red]: !!hasError && !!errors && errors[0] !== 'unscrapped' },
        { [style.yellow]: !!errors && errors[0] === 'unscrapped' },
        { [style.lightBlue]: !!value })}>
        <Cleave className={classNames(inputStyle.input, style.weight)}
                type={this.isAppleMobile ? 'text' : 'tel'}
                name={name}
                value={value}
                options={{
                  numeral: true,
                  numeralThousandsGroupStyle: 'thousand',
                  numeralDecimalScale: 2,
                  numeralPositiveOnly: true,
                }}
                onFocus={(e: Event) => handleFocusInputText ? handleFocusInputText(e) : undefined}
                onChange={handleChangeCleave}
                onBlur={handleBlurCleave}
                onInit={handleInit}
                htmlRef={handleRef}/>
        <section className={style.units}>
          {units.map((unit: string, index: number) =>
            <span key={index}
                  className={classNames(style.unit, { [style.selected]: unit === weightUnit.value })}
                  onClick={() => (weightUnit.value !== unit) && handleChangeWeightUnit(unit)}>{unit}</span>)}
        </section>
      </section>
    )
  }
}

InputWeight.propTypes = {
  weightUnit: PropTypes.object,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  hasError: PropTypes.bool,
  errors: PropTypes.array,
  value: PropTypes.string,
  handleFocusInputText: PropTypes.func,
  handleChangeWeightUnit: PropTypes.func.isRequired,
  handleChangeCleave: PropTypes.func.isRequired,
  handleBlurCleave: PropTypes.func.isRequired,
  handleInit: PropTypes.func.isRequired,
  handleRef: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/elements/InputWeight/InputWeight.jsx